import React, { useRef, useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import "./index.css";
import RedesSociais from "../../RedesSociais";

export default function ContatoHome() {
  const form = useRef();
  const [enviado, setEnviado] = useState(false);

  const fnEnviarFormulario = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_ez3s723",
        "template_a6q4hfl",
        form.current,
        "bMRy8pLjmMRAas5jO"
      )
      .then(
        (result) => {
          setEnviado(true);
          setTimeout(() => {
            setEnviado(false);
          }, 5000);
          form.current.reset();
        },
        (error) => {
          console.error(error);
        }
      );
  };

  return (
    <>
      <div className="divContatoHome ">
        <div
          className="row"
          style={{ marginTop: 60, maxWidth: 1500, width: "100%" }}
        >
          {/* <div className="col-md-6 d-flex justify-content-center align-items-center p-4">
            <div className="divTextoContatoHome">
              <div className="tituloContatoHome">Fala com a gente, bb</div>
              <div className="textoContatoHome">
                Quer fazer um filme maneiro pro seu cliente ou para o seu
                próprio negócio? Manda uma breve mensagem contanto do projeto e
                entraremos em contato!
                <br />
                <br />
                <br />
                trovis@filofilmes.com
                <br />
                +55 (19) 98828-9128
                <br />
                <br />
                <br />
                <RedesSociais />
              </div>
            </div>
          </div> */}
          <div className="col-md-6 d-flex justify-content-center align-items-center p-4">
            <div className="divTextoContatoHome">
              <div className="tituloContatoHome">Fala com a gente, bb</div>
              <div className="d-flex justify-content-center mt-2">
                <RedesSociais />
              </div>
            </div>
          </div>
          <div
            className="p-5 d-flex justify-content-center flex-column align-items-center text-center pointer hoverZoom"
            onClick={() => window.open("mailto:doisbar@filofilmes.com")}
          >
            <div style={{ color: "#e48b38", marginBottom: -10 }}>
              creative director
            </div>
            <div style={{ fontSize: 30, color: "#fff", fontWeight: 300 }}>
              bárbara napolitano
            </div>
            <div style={{ color: "#b9b9b9", marginTop: -5 }}>
              doisbar@filofilmes.com
            </div>
          </div>
          <div
            className="p-5 d-flex justify-content-center flex-column align-items-center text-center pointer hoverZoom"
            onClick={() => window.open("mailto:trovis@filofilmes.com")}
          >
            <div style={{ color: "#e48b38", marginBottom: -10 }}>
              founder & director
            </div>
            <div style={{ fontSize: 30, color: "#fff", fontWeight: 300 }}>
              erik trovilho
            </div>
            <div style={{ color: "#b9b9b9", marginTop: -5 }}>
              trovis@filofilmes.com
            </div>
          </div>
          <div
            className="p-5 d-flex justify-content-center flex-column align-items-center text-center pointer hoverZoom"
            onClick={() => window.open("mailto:marcosbatista@filofilmes.com")}
          >
            <div style={{ color: "#e48b38", marginBottom: -10 }}>
              project manager
            </div>
            <div style={{ fontSize: 30, color: "#fff", fontWeight: 300 }}>
              marcos batista
            </div>
            <div style={{ color: "#b9b9b9", marginTop: -5 }}>
              doisbar@filofilmes.com
            </div>
          </div>
          {/* <div className="col-md-6 d-flex justify-content-center align-items-center p-4">
            {enviado ? (
              <div className="mensagemEnviadaHome">
                Mensagem enviada com sucesso!
              </div>
            ) : (
              <form
                ref={form}
                onSubmit={fnEnviarFormulario}
                className="divFormularioHome"
              >
                <label className="tituloContatoFormularioHome mt-5 mt-md-0">
                  E-mail
                </label>
                <input className="emailInputHome" type="email" name="email" />

                <label className="tituloContatoFormularioHome mt-4">
                  Message
                </label>
                <textarea className="mensagemInputHome" name="message" />
                <div className="d-flex justify-content-end mt-4">
                  <input
                    className="botaoFormularioHome"
                    type="submit"
                    value="Enviar"
                  />
                </div>
              </form>
            )}
          </div> */}
        </div>
      </div>
    </>
  );
}
